import type { DonorDonation } from '@/types/donorFinancialYear'
import type { GivingRecordRow } from '@/types/givingRecord'

/** Maps a giving-record table row to the shared donation list shape. */
export function givingRecordRowToDonorDonation(row: GivingRecordRow): DonorDonation {
  return {
    id: row.id,
    state: 'received',
    charity: row.charity,
    amount: row.amountPence,
    giftaid: row.giftAidPence,
    giftAidDeclared: row.giftAidDeclared,
    time: row.time,
    source: row.source === 'manual' ? 'manual' : row.sourceLabel,
    sourceCategory: row.sourceCategory,
    notes: row.notes,
    receipts: row.receipts,
    charityLogoUrl: row.charityLogoUrl,
    charityBrandColor: row.charityBrandColor,
    recurringSeriesId: row.recurringSeriesId,
    scheduledOccurrenceDate: row.scheduledOccurrenceDate,
    individuallyEdited: row.individuallyEdited,
  }
}
